import React from "react";
import cn from "../../../lib/cn";
import H4 from "../../../shared/typography/H4";
import P from "../../../shared/typography/P";

const Table = ({ heading, tableData, headingRowClass = "", RowClass = "" }) => {
    return (
        <table className="w-full ">
            <thead>
                <tr
                    className={cn(
                        "flex justify-between items-center gap-5 my-1",
                        headingRowClass
                    )}
                >
                    {heading?.map((item, index) => (
                        <td key={index}>
                            <div>
                                <H4 className=" text-sm font-medium md:text-base xl:text-base  text-secondary">
                                    {item}
                                </H4>
                            </div>
                        </td>
                    ))}
                </tr>
            </thead>
            <tbody>
                {tableData?.map((item, index) => (
                    <tr
                        key={index}
                        className={cn(
                            "flex justify-between items-center border border-b gap-5 my-1",
                            RowClass,
                            {
                                "border-none": index === tableData?.length - 1,
                            }
                        )}
                    >
                        <td className="w-1/2">
                            <div>
                                <P className=" text-xs md:text-sm text-nowrap xl:text-sm text-primary">
                                    {item.Description}
                                </P>
                            </div>
                        </td>
                        <td className="w-1/2">
                            <div className="flex flex-col justify-start items-end">
                                <p className="text-end text-xs text-nowrap font-semibold text-primary">
                                    {item["Plan Details"]}
                                </p>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Table;
